
import React, { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { isBrowser } from "@/utils/runtime";

interface StickyCTAProps {
  onButtonClick: () => void;
}

const TocFotosStickyCTA: React.FC<StickyCTAProps> = ({ onButtonClick }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  useEffect(() => {
    if (!isBrowser || !isClient) return;
    
    const depoimentosSection = globalThis.document.getElementById("depoimentos");
    if (!depoimentosSection) return;

    // Use IntersectionObserver to avoid forced reflows
    const observer = new IntersectionObserver(
      ([entry]) => {
        // Show CTA when the depoimentos section has scrolled out of view (above viewport)
        setIsVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0
      }
    );

    observer.observe(depoimentosSection);
    
    return () => {
      observer.disconnect();
    };
  }, [isClient]);

  if (!isVisible || !isClient) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white shadow-lg py-3 z-40">
      <div className="container max-w-7xl mx-auto px-4 flex justify-between items-center">
        <p className="text-[#261E13] font-medium hidden md:block">
          Transforme seu imóvel com fotos profissionais
        </p>
        <Button 
          onClick={onButtonClick}
          className="bg-[#FF5605] hover:bg-[#E14D04] text-white rounded-full px-6 py-2"
          size="lg"
        >
          Solicitar Orçamento
        </Button>
      </div>
    </div>
  );
};

export default TocFotosStickyCTA;
